export enum TARGETING_AGE_NAME {
  adults18to24 = 'A18to24',
  adults21to34 = 'A21to34',
  adults25to34 = 'A25to34',
  adults35to49 = 'A35to49',
  adults50up = 'A50up',
  females18to24 = 'FA18to24',
  females21to34 = 'FA21to34',
  females25to34 = 'FA25to34',
  females35to49 = 'FA35to49',
  females50up = 'FA50up',
  males18to24 = 'MA18to24',
  males21to34 = 'MA21to34',
  males25to34 = 'MA25to34',
  males35to49 = 'MA35to49',
  males50up = 'MA50up',
}

export const allTargetingAgeNames: TARGETING_AGE_NAME[] = [
  TARGETING_AGE_NAME.adults18to24,
  TARGETING_AGE_NAME.adults21to34,
  TARGETING_AGE_NAME.adults25to34,
  TARGETING_AGE_NAME.adults35to49,
  TARGETING_AGE_NAME.adults50up,
  TARGETING_AGE_NAME.females18to24,
  TARGETING_AGE_NAME.females21to34,
  TARGETING_AGE_NAME.females25to34,
  TARGETING_AGE_NAME.females35to49,
  TARGETING_AGE_NAME.females50up,
  TARGETING_AGE_NAME.males18to24,
  TARGETING_AGE_NAME.males21to34,
  TARGETING_AGE_NAME.males25to34,
  TARGETING_AGE_NAME.males35to49,
  TARGETING_AGE_NAME.males50up,
];

export enum GENDER {
  all = 'all',
  female = 'female',
  male = 'male',
}

export const GENDER_TITLE: Record<GENDER, string> = {
  [GENDER.all]: 'All',
  [GENDER.male]: 'Male',
  [GENDER.female]: 'Female',
};

export enum AGE {
  from18to24 = 'from18to24',
  from21to34 = 'from21to34',
  from25to34 = 'from25to34',
  from35to49 = 'from35to49',
  from50 = 'from50',
}

export const allAges: AGE[] = [AGE.from18to24, AGE.from25to34, AGE.from35to49, AGE.from50];
export const allMatureAges: AGE[] = [AGE.from21to34, AGE.from35to49, AGE.from50];

export const AGE_TITLE: Record<AGE, string> = {
  [AGE.from18to24]: '18-24',
  [AGE.from21to34]: '21-34',
  [AGE.from25to34]: '25-34',
  [AGE.from35to49]: '35-49',
  [AGE.from50]: '50+',
};
